/*eslint react-hooks/exhaustive-deps: "off"*/
/*eslint no-unused-vars: "off"*/
import React, {useEffect, useState} from 'react';
import MapBase from "./MapBase";
import {PALETTE_YlOrRd_9, TRANSPARENT_COLOR} from "../../utils/Palette";
import useMapProps from "./useMapProps";
import {MapPropsProvider} from "./MapPropsContext";
import WidgetContainer from "./widgets/WidgetContainer";
import {arrayToRgb, getApiUrl, getLastYear, makeTableSorterFn, numberWithCommas} from "../../utils";
import WidgetServiceCodeForStats from "./widgets/WidgetServiceCodeForStats";
import RMateChartStatsCellular from "./r_mate_chart/RMateChartStatsCellular";
import WidgetLegend from "./widgets/WidgetLegend";
import Seperator from "./widgets/Seperator";
import WidgetStatisticsTable from "./widgets/WidgetStatisticsTable";
import WidgetSelectYearDetail from "./widgets/WidgetSelectYearDetail";
import WidgetDistrictSelect from "./widgets/WidgetDistrictSelect";
import WidgetRisingTabs from "./widgets/WidgetRisingTabs";
import WidgetToolbar from "./widgets/WidgetToolbar";
import {WELL_KNOWN_POSITION} from "../../Constants";

/*
  지역별 이동통신 현황
  지도 + 통계
 */


function MapStatsCellular() {

  const [fillColorLegend, setFillColorLegend] = useState([]);

  const mapProps = useMapProps({
    INITIAL_VIEW_STATE: {
      ...WELL_KNOWN_POSITION.세종특별자치시,
      zoom: 8,
    },
    INITIAL_GEOJSON_EXTRA_PARAMS: {
      checkStartYear: (getLastYear() - 5).toString(),
      checkStartMonth: 1,
      checkEndYear: (getLastYear()).toString(),
      checkEndMonth: 12,
      currentDistrictCode: '',
    },
    INITIAL_GEOJSON_POLYGON_LAYER_PROPS: {
      getHoverHtml: (feature, mapDistrictStats) => {
        const [metricObject] = mapDistrictStats;
        const {properties: {pk, name}} = feature;
        const code = pk;
        const obj = metricObject[code];
        if (obj) {
          const {total} = obj;
          return `<span class='fontStyle'>${name}</span><br/> 
                   무선국 수: ${numberWithCommas(total)} 개`;
        }
        return `<span class='fontStyle'>${name}</span><br/>
                무선국 수 : 0 개`;
      },
      getLevelFillColor: ({properties: {pk}}, mapDistrictStats) => {
        const [metricObject, metricMax] = mapDistrictStats;
        const code = pk;
        const obj = metricObject[code];
        if (obj) {
          const {total} = (metricObject[code] || {total: 1});
          if (total >= 1) {
            const index = Math.floor(PALETTE_YlOrRd_9.length * (total - 1) / metricMax);
            return PALETTE_YlOrRd_9[index];
          }
          return TRANSPARENT_COLOR;
        }
        return TRANSPARENT_COLOR;
      },
    },
    INITIAL_WIDGET_STATE: {
      service_code_stats_list: ["2G", "3G", "LTE", "5G"],
      isRangeByYear: false, // 기간조회를 기본으로 설정
    },
  });

  /*
    서버 Ajax 통신을 위해 String을 만듭니다.
   */
  const settingchkRadSvcString = (checkList) => {
    // as-is 의 문자열 만들기 모양 : "2G,3G,LTE"
    return checkList.toString();
  };


  const {
    widgetState,
    dataResponseList,
    mapDistrictStats, setMapDistrictStats, isChangedMapDistrictStats,
    clickedPolygonGeojsonObjects,
    geojsonExtraParams,
    currentDistrictCode,
    setGeojsonExtraParams,
    setCurrentDistrictCode,
    setChartAjaxParams,
    chartDivVisible,
  } = mapProps;

  useEffect(() => {
    if(chartDivVisible) return;
    const metricObject = {};
    const {service_code_stats_list, isRangeByYear} = widgetState;
    if (dataResponseList.length > 0 && service_code_stats_list.length > 0) {
      const firstDataLayer = dataResponseList[0];
      for (let [code] of Object.entries(firstDataLayer)) {
        let total = 0;
        const firstCode = firstDataLayer[code];
        for (let service_code of service_code_stats_list) {
          const codeVal = firstCode[service_code];
          if (codeVal) {
            total += codeVal;
          }
        }
        metricObject[code] = {total};
      }
    }
    const metricMax = Math.max(...Object.values(metricObject).map(obj => obj.total));

    const newMapDistrictStats = [metricObject, metricMax];
    if (isChangedMapDistrictStats(newMapDistrictStats)) {
      setMapDistrictStats(newMapDistrictStats);


      ////////// ajax new_param 설정////////////
      // 연월 세팅
      const {checkStartYear, checkStartMonth, checkEndYear, checkEndMonth} = geojsonExtraParams;

      let paramStartMonth = "";
      let paramEndMonth = "";

      if (checkStartMonth < 10) {
        paramStartMonth = '0' + checkStartMonth.toString();
      } else {
        paramStartMonth = checkStartMonth.toString();
      }

      if (checkEndMonth < 10) {
        paramEndMonth = '0' + checkEndMonth.toString();
      } else {
        paramEndMonth = checkEndMonth.toString()
      }
      window.searchStart = checkStartYear.toString() + paramStartMonth;
      window.searchEnd = checkEndYear.toString() + paramEndMonth;

      let paramChk = "";
      // 기간조회(Y)인지 연도상세인지 세팅
      if (isRangeByYear) { // true = 연도상세
        window.searchChk = 'N';
        paramChk = 'N';
      } else if (!isRangeByYear) {
        window.searchChk = 'Y';
        paramChk = 'Y';
      }
      window.chkRadSvcString = settingchkRadSvcString(service_code_stats_list);
      window.prm_check = service_code_stats_list;
      window.sidoCode = (currentDistrictCode || '').length < 2
        ? ''
        : currentDistrictCode.substr(0, 2);

      window.new_param = 'sidoCode=' + window.sidoCode +
        '&searchStart=' + window.searchStart +
        '&searchEnd=' + window.searchEnd +
        '&searchChk=' + window.searchChk +
        '&chkRadSvcString=' + window.chkRadSvcString +
        '&prm_check_all=0';
      ////////// ajax new_param 끝 ////////////

      // chart 코드 수정으로 시도코드~prm_check_all 추가
      setChartAjaxParams({
        searchStart: checkStartYear.toString() + paramStartMonth,
        searchEnd: checkEndYear.toString() + paramEndMonth,
        sidoCode: window.sidoCode,
        searchChk: paramChk,
        chkRadSvcString: settingchkRadSvcString(service_code_stats_list),
        prm_check_all: '0',
        prm_check: service_code_stats_list,
      });

      // setChartLoadingTrigger('Y');
    } else { // 기간조회 <->상세조회 토글시에도 차트 불러오기위해 조건문 추가 -> Axios통신시 바뀌었는지 확인하는 로직도 추가하였습니다.
      console.log(geojsonExtraParams);
      const {checkStartYear, checkStartMonth, checkEndYear, checkEndMonth} = geojsonExtraParams;

      let paramStartMonth = "";
      let paramEndMonth = "";

      if (checkStartMonth < 10) {
        paramStartMonth = '0' + checkStartMonth.toString();
      } else {
        paramStartMonth = checkStartMonth.toString();
      }

      if (checkEndMonth < 10) {
        paramEndMonth = '0' + checkEndMonth.toString();
      } else {
        paramEndMonth = checkEndMonth.toString()
      }
      const searchStart = checkStartYear.toString() + paramStartMonth;
      const searchEnd = checkEndYear.toString() + paramEndMonth;

      window.searchStart = searchStart;
      window.searchEnd = searchEnd;

      let searchChk = "";
      if (isRangeByYear) { // true = 연도상세
        searchChk = 'N';
        window.searchChk = 'N';
      } else if (!isRangeByYear) {
        searchChk = 'Y';
        window.searchChk = 'Y';
      }

      setChartAjaxParams(prev => ({
        ...prev,
        searchChk,
        searchStart,
        searchEnd,
      }));
    }


  }, [dataResponseList, widgetState, geojsonExtraParams, currentDistrictCode]);
/* ////1005_시군구 클릭 임시막기
  useEffect(() => {
    if(chartDivVisible) return;
    if (clickedPolygonGeojsonObjects.length > 0) {
      const firstLayer = clickedPolygonGeojsonObjects[0];
      const {properties: {name, pk}} = firstLayer;
      if ((pk || '').length <= 2) {
        setCurrentDistrictCode(pk);
        // console.log(`${name}(#${pk})를 클릭했습니다.`);
        // setChartLoadingTrigger('Y');
      }
    }
  }, [clickedPolygonGeojsonObjects]);
*/
  // 범례
  useEffect(() => {
    if(chartDivVisible) return;
    const [metricObject, metricMax] = mapDistrictStats;
    if (window.isFinite(metricMax) && metricMax >= 9) {
      setFillColorLegend(
        [...Array(9).keys()].map(colorIndex => {
          const boundary = (metricMax / 9) * (colorIndex + 1);
          const index = Math.floor(PALETTE_YlOrRd_9.length * (boundary - 1) / metricMax);
          const colorRgb = arrayToRgb(PALETTE_YlOrRd_9[index]);
          return [colorRgb, boundary];
        }).reverse()
      );
    } else { // 데이터가 없을때
      setFillColorLegend(
        [...Array(1).keys()].map(colorIndex => {
          const boundary = 0;
          const colorRgb = '#ffffd9';
          return [colorRgb, boundary];
        }).reverse()
      );
    }
  }, [mapDistrictStats]);

  useEffect(() => {
    if(chartDivVisible) return;
    setGeojsonExtraParams(prev => ({
      ...prev,
      currentDistrictCode,
    }));

    if ((currentDistrictCode || '').length <= 2) {
      // setChartLoadingTrigger('Y')
    }
  }, [currentDistrictCode]);

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase isHideWidgetToggleClustering={true} isHideWidgetMapLayerTypes={true}>
        <WidgetContainer>
          <div>
            <WidgetDistrictSelect isShowDistrictLayerFromGeoserver={true} onlyLv1={true} />
            <WidgetSelectYearDetail isSince1988={true} />
            <Seperator/>
            <WidgetServiceCodeForStats/>
          </div>
        </WidgetContainer>
      </MapBase>
      <WidgetRisingTabs height={'355px'} titleOnInit={["지역별 서비스별 무선국 수", "년간 서비스별 무선국 변동"]}>
        <WidgetStatisticsTable
          fetchUrl={getApiUrl({type: "type1"})}
          type={"type1"}
          getTitle={(layer) => `지역별 서비스별 무선국 수`}
          processor={objectList => {
            const gugunList = Array.from(new Set(objectList.map(({gugun}) => gugun)));
            const serviceNameList = Array.from(new Set(objectList.map(({service_cd}) => service_cd)));

            const rowList = serviceNameList.map(res_service_name => {
              return objectList
                .filter(({service_cd}) => res_service_name === service_cd)
                .reduce((acc, {gugun, cnt}) => {
                  acc[gugun] = cnt;
                  return acc;
                }, {service_cd: res_service_name});
            });

            const columns = gugunList.map(gugun => ({
              title: gugun,
              dataIndex: gugun,
              key: gugun,
              width: 140,
              sorter: makeTableSorterFn(gugun),
              render: value => <div style={{textAlign: 'right'}}>{numberWithCommas(value)}</div>,
            }));
            return [columns, rowList];
          }}
          columns={[
            {title: '순번', dataIndex: 'index', key: 'index', width: 75, sorter: makeTableSorterFn('index'), fixed: 'left'},
            {
              title: '서비스명',
              dataIndex: 'service_cd',
              key: 'service_cd',
              width: 100,
              sorter: makeTableSorterFn('service_cd'),
              fixed: 'left'
            },
          ]}
        />
        <WidgetStatisticsTable
          fetchUrl={getApiUrl({type: "type3"})}
          type={"type3"}
          getTitle={(layer) => `년간 서비스별 무선국 변동`}
          processor={objectList => {
            const yearList = Array.from(new Set(objectList.map(({year}) => year)));
            const serviceNameList = Array.from(new Set(objectList.map(({service_cd}) => service_cd)));

            const rowList = serviceNameList.map(res_service_name => {
              return objectList
                .filter(({service_cd}) => res_service_name === service_cd)
                .reduce((acc, {year, cnt}) => {
                  acc[year] = cnt;
                  return acc;
                }, {service_cd: res_service_name});
            });

            const columns = yearList.map(year => ({
              title: year,
              dataIndex: year,
              key: year,
              width: 120,
              sorter: makeTableSorterFn(year),
              render: value => <div style={{textAlign: 'right'}}>{numberWithCommas(value)}</div>,
            }));
            return [columns, rowList];
          }}
          columns={[
            {title: '순번', dataIndex: 'index', key: 'index', width: 75, sorter: makeTableSorterFn('index')},
            {
              title: '서비스명',
              dataIndex: 'service_cd',
              key: 'service_cd',
              width: 100,
              sorter: makeTableSorterFn('service_cd')
            },
          ]}
        />
      </WidgetRisingTabs>
      <RMateChartStatsCellular disabled={widgetState.service_code_stats_list.length === 0}/>
      {fillColorLegend.length > 0 && <WidgetLegend fillColorLegend={fillColorLegend}  titleColorLegend={'무선국 수'}  unitColorLegend={'개'}/>}
      <WidgetToolbar/>
    </MapPropsProvider>
  );
}

export default MapStatsCellular;
